import React from 'react';
import './RoadProjects.css';

const RoadProjects = () => {
  const projects = [
    {
      title: "Nsukka–Unadu Road",
      description:
        "Rehabilitation of the main artery connecting several rural communities to the town center, improving mobility and trade.",
    },
    {
      title: "Itchi–Iheaka Linkway",
      description:
        "Newly constructed paved road to reduce travel time between villages and enhance access to healthcare and education.",
    },
    {
      title: "Ajuona–Ovoko Access Road",
      description:
        "Ongoing road expansion project with proper drainage and solar street lighting for enhanced safety and night travel.",
    },
  ];

  return (
    <section className="road-projects">
      <div className="road-projects-wrapper">
        <h2 className="road-projects-section-title">Road Construction Projects</h2>
        <div className="road-projects-grid">
          {projects.map((project, index) => (
            <div className="road-projects-card" key={index}>
              <h3>{project.title}</h3>
              <p>{project.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RoadProjects;